import { type ClassificationPatchRequest, QueueItemDetail } from '@rp/contracts'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useReadySession } from '../../session/useSession'
import { queueKeys } from '../queue/queries'

export type ReclassifyInput = ClassificationPatchRequest

export const useReclassify = (itemId: string) => {
  const { api } = useReadySession()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: ReclassifyInput) =>
      (
        await api.request(QueueItemDetail, {
          method: 'PATCH',
          path: `/v1/queue/${itemId}/classification`,
          body: input,
        })
      ).data,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: queueKeys.all }),
  })
}
